__turbopack_context__.v({
  "availability": "_9rYa0q_availability",
  "availabilityInset": "_9rYa0q_availabilityInset",
  "buyButton": "_9rYa0q_buyButton",
  "buyButtonGreen": "_9rYa0q_buyButtonGreen",
  "card": "_9rYa0q_card",
  "cardControls": "_9rYa0q_cardControls",
  "cardHeader": "_9rYa0q_cardHeader",
  "countdown": "_9rYa0q_countdown",
  "description": "_9rYa0q_description",
  "dim": "_9rYa0q_dim",
  "mantine-Badge-label": "_9rYa0q_mantine-Badge-label",
  "mantine-Text-root": "_9rYa0q_mantine-Text-root",
  "newItem": "_9rYa0q_newItem",
  "price": "_9rYa0q_price",
  "sampleWrapper": "_9rYa0q_sampleWrapper",
  "title": "_9rYa0q_title",
  "titleRow": "_9rYa0q_titleRow",
  "type": "_9rYa0q_type",
  "wishlist": "_9rYa0q_wishlist",
});
